var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-wrapper"},[_c('div',{staticClass:"field-wrapper"},[_c('v-textarea',{staticClass:"field textarea",attrs:{"label":"Notes","disabled":_vm.editableNote,"rows":"5","dense":"","prepend-icon":"mdi-comment"},model:{value:(_vm.getNotes),callback:function ($$v) {_vm.getNotes=$$v},expression:"getNotes"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }